import { Input, Directive } from '@angular/core';
import { ColumnDefinition } from '../../core-services/Tables/ColumnInfo';
import { Table } from '../../core-services/Tables/Table';

/*
The following two directives are designed to only really work with
Table component in this project.
*/

@Directive({
    selector: '[register-column]',
    host: {
        '[class.hidden]': '!showMe'
    },
    standalone: false
})
export class RegisterColumnDirective {
    @Input('register-column')
    tableInfo: ColumnDefinition;
    table: Table<any>;

    get showMe() {
        if (!this.table) {
            return false;
        }
        return this.table.columnInfo.display(this.tableInfo.columnId);
    }
}

@Directive({
    selector: '[show-column]',
    host: {
        '[class.hidden]': '!showMe'
    },
    standalone: false
})
export class ShowColumnDirective {
    @Input('show-column')
    columnId: string;
    table: Table<any>;

    get showMe() {
        if (!this.table && this.columnId) {
            return false;
        }
        return this.table.columnInfo.display(this.columnId);
    }
}
